module.exports = __webpack_public_path__ + "skin_archivist_logo.png?257f2f92d94eeee3752c44430c65d058";


//////////////////
// WEBPACK FOOTER
// ./src/img/sfondi/skin_archivist_logo.png
// module id = 360
// module chunks = 0